import { createContext } from 'react';
import { UseFlowChartContextProps } from './useFlowChart.types';

export const UseFlowChartContext = createContext({} as UseFlowChartContextProps);
export default UseFlowChartContext;
